const API_URL = import.meta.env.VITE_API_URL || '';

const PICSART_APP_URL = import.meta.env.VITE_PICSART_APP_URL || '';

const LIBRARY_TABS_KEY = import.meta.env.VITE_LIBRARY_TABS_KEY || '';

const LIBRARY_BASE_URL = import.meta.env.VITE_LIBRARY_URL || '';

const LIBRARY_SECTIONS_URL = `${LIBRARY_BASE_URL}/hubs/${LIBRARY_TABS_KEY}/grids/flow?landingType=flow&expand=uploadItems,textItems`;

const LIBRARY_TRENDING_URL = `${LIBRARY_BASE_URL}/hubs/${LIBRARY_TABS_KEY}/trending`;

const FLOW_LANDINGS_URL = `${LIBRARY_BASE_URL}/flow-landings/slug`;

const MAGIC_FLOW_WEBHOOK_URL = `${API_URL}/workflows/magic-flow-webhook`;

const SUBMIT_WEB_HOOK_URL = `${MAGIC_FLOW_WEBHOOK_URL}/submit`;

const CREDIT_CALCULATOR_URL = `${API_URL}/workflows/magic-flow-webhook-calculator/execute`;

const MOBILE_EDITOR_URL = 'picsart://apps';

const SIGNOUT_URL = `${API_URL}/users/signout.json`;

const DRIVE_FILES_URL = `${API_URL}/drive/v1/files`;

export {
  API_URL,
  PICSART_APP_URL,
  LIBRARY_TABS_KEY,
  LIBRARY_BASE_URL,
  LIBRARY_SECTIONS_URL,
  LIBRARY_TRENDING_URL,
  FLOW_LANDINGS_URL,
  MAGIC_FLOW_WEBHOOK_URL,
  SUBMIT_WEB_HOOK_URL,
  CREDIT_CALCULATOR_URL,
  MOBILE_EDITOR_URL,
  SIGNOUT_URL,
  DRIVE_FILES_URL,
};
